import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import FrameInformationContainer from '../../../steps/components/FrameInformation/FrameInformationContainer.js';
import { ConfigurationTotalPriceContainer } from '../ConfigurationTotalPrice/ConfigurationTotalPriceContainer.js';

const RxGlassesTopBar = ()=>{
    const isPhone = MediaQuery.useIsPhone();
    return /*#__PURE__*/ React.createElement("div", {
        className: "rxglasses-topbar"
    }, !isPhone && /*#__PURE__*/ React.createElement(FrameInformationContainer, null), /*#__PURE__*/ React.createElement(ConfigurationTotalPriceContainer, null));
};

export { RxGlassesTopBar };
//# sourceMappingURL=RxGlassesTopBar.js.map
